import {deserialize, serialize, inheritSerialization} from "cerialize";

import BaseEntity from "./BaseEntity";
import TableColumn from "./TableColumn";
import AppConfig from "../AppConfig";

@inheritSerialization(BaseEntity)
export default class PosPembayaran extends BaseEntity {

    @serialize
    @deserialize
    public nama: string = "";

    @serialize
    @deserialize
    public keterangan: string = "";

    public table() {
        const {nama, keterangan} = this;

        return {nama, keterangan};
    }

    public namaFeedback() {
        return this.defaultPropertyFeedback('nama');
    }

    public static columnName(): Array<TableColumn> {
        const kegiatan = new PosPembayaran().table();
        let keys = Object.keys(kegiatan);

        return keys.map((field: any, index: number) => {
            const tableColumn = new TableColumn();
            tableColumn.name = AppConfig.getVm().$t(`label.${field}`);

            if (index > 1) {
                tableColumn.position = 'centered';
            }

            return tableColumn;
        });
    }

}
